import http from '@/utils/http'



// 获取用户已注册的信息
export function bindAccount(headers, data) {
  const config = {
    method: 'post',
    url: `/cs/admin/shopAccount/bindPhone`,
    data,
    headers
  }
  return http(config)
}

export function getConfig(headers, url) {
  const config = {
    method: 'get',
    url: `/cs/callback/wechat/jsEncryption?url=${url}`,
    headers
  }
  return http(config)
}


export function checkCoupon(headers, code) {
  const config = {
    method: 'get',
    url: `/cs/member/coupon/use/${code}`,
    headers
  }
  return http(config)
}

export function getCheckList(headers) {
  const config = {
    method: 'get',
    url: `/cs/admin/shopAccount/h5/write/off/info?pageSize=99999`,
    headers
  }
  return http(config)
}



